<template>

  <v-switch v-bind="{ ...$attrs, ...commonAttrs }" />
  
</template>

<script>
// https://vuejs.org/guide/components/attrs.html#disabling-attribute-inheritance
export default {
  inheritAttrs: false
}
</script>

<script setup>

/**
 * A simple wrapper for Vuetify's <v-switch>.
 * 
 * https://dev.to/kouts/create-wrapper-components-for-vuetify-components-2aah
 * https://v3-migration.vuejs.org/breaking-changes/listeners-removed.html
 */

import { computed, useAttrs } from 'vue'

const props = defineProps({

  validator: {
    type: Object,
  },

})

const attrs = useAttrs()

const commonAttrs = computed(() => {

  const output = {}

  // TODO: set color

  if (props.validator) {
    output.validator = null // don't pass the validator prop along to v-text-field
    // output.errorMessages = ['test'] // props.validator.$errors.map(e => e.$message) // TODO: fix
  }

  // If no color prop was passed, default to indigo
  if (!('color' in attrs)) {
    output.color = 'indigo'
  }

  return output

})

</script>
